import React from "react";
import "./PreventionPage.css";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import DefaultPage from "../DefaultPage/DefaultPage";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import Loader from "../../components/Loader";
import DynamicZoneBuilder from "../../components/DynamicZoneBuilder.js";

const PreventionPage = () => {
  const { loading, error, data } = useFetch(
    `${config.api}/api/prevention-page?populate[content][on][bloky.images][populate]=*&populate[content][on][bloky.text][populate]=*&populate[content][on][bloky.files][populate][files][populate]=*`
  );

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání třídy" />;

  if (!data || !data.data)
    return <DefaultPage message="Nepodařilo se získat detail o třídě" />;

  document.title = data?.data?.title;
  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction title={data?.data?.title} />
      <div className="container container-background d-flex flex-column gap-4 p-5">
        <DynamicZoneBuilder components={data?.data?.content} />
      </div>
      <Footer />
    </div>
  );
};

export default PreventionPage;
